import type { JSX } from 'react';
import { generatePath } from 'react-router';

import { Link } from 'Components/Buttons/Buttons';
import { CollapsibleModal } from 'Components/Modal/CollapsibleModal/CollapsibleModal';
import { TPRM_SERVICE_DASHBOARD, UCRM_USE_CASE_DASHBOARD } from 'Config/PathTemplates';
import { DueDiligenceModule, ProductModule } from 'Models/ProductModule';

import styles from './AssessmentSubjectsDisplayModal.module.css';

export interface SelectedAssessmentSubjectDetails {
    assessmentSubjectId: string;
    assessmentSubjectName: string;
    organizationId: string;
    organizationName: string;
}

export interface AssessmentSubjectsDisplayModalProps {
    hideModal: () => void;
    module: DueDiligenceModule;
    selectedAssessmentSubjects: SelectedAssessmentSubjectDetails[];
    subtitle: string;
}

export const AssessmentSubjectsDisplayModal = (props: AssessmentSubjectsDisplayModalProps): JSX.Element => {
    const serviceDashboardPathTemplate = props.module === ProductModule.UCRM ? UCRM_USE_CASE_DASHBOARD : TPRM_SERVICE_DASHBOARD;

    const selectedServiceListing = props.selectedAssessmentSubjects.map((service) => (
        <div className={styles.detailsContainer} key={service.assessmentSubjectId}>
            <Link openInNewTab to={generatePath(serviceDashboardPathTemplate, { third_party_id: service.organizationId, service_id: service.assessmentSubjectId })} size="sm">{`${service.organizationName} - ${service.assessmentSubjectName}`}</Link>
        </div>
    ));

    return <CollapsibleModal displayItems={selectedServiceListing} headerText={{ text: props.module === ProductModule.UCRM ? 'Use Cases' : 'Third-Party Services', secondaryText: props.subtitle }} hideModal={props.hideModal} />;
};
